import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ProfileComponent } from './profile.component';
import { ProfileRoutingModule } from './profile-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TabMenuModule } from 'primeng/tabmenu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../core/directives/directives.module';
import { PatientComponent } from './patient/patient.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { MessagesModule } from 'primeng/messages';
import { AddressesComponent } from './addresses/addresses.component';
import { MedicalComponent } from './medical/medical.component';
import { PaymentComponent } from './payment/payment.component';

@NgModule({
  declarations: [
    ProfileComponent,
    PatientComponent,
    InsuranceComponent,
    AddressesComponent,
    MedicalComponent,
    PaymentComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProfileRoutingModule,
    SharedModule,
    CardModule,
    DividerModule,
    ProgressSpinnerModule,
    DirectivesModule,
    TabMenuModule,
    CheckboxModule,
    ButtonModule,
    TagModule,
    MessagesModule,
  ],
})
export class ProfileModule {}
